import * as React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import dayjs from 'dayjs'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'

function MonthPicker({ currentMonth, onMonthChange }) {
  const [year, setYear] = React.useState(currentMonth.getFullYear())
  const [open, setOpen] = React.useState(false)

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  const handleMonthSelect = (monthIndex) => {
    const newDate = new Date(year, monthIndex, 1)
    onMonthChange(newDate)
    setOpen(false)
  }

  const nextYear = () => setYear(year + 1)
  const prevYear = () => setYear(year - 1)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'w-[180px] justify-start text-left font-normal',
            !currentMonth && 'text-muted-foreground'
          )}
        >
          {dayjs(currentMonth).format('MMMM YYYY')}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <div className="p-3">
          <div className="flex items-center justify-between mb-2">
            <Button variant="outline" size="icon" onClick={prevYear}>
              <ChevronLeft className="h-4 w-4" />
            </Button>
            <div className="font-semibold">{year}</div>
            <Button variant="outline" size="icon" onClick={nextYear}>
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
          <div className="grid grid-cols-3 gap-2">
            {months.map((month, index) => (
              <Button
                key={month}
                variant={
                  currentMonth.getMonth() === index &&
                  currentMonth.getFullYear() === year
                    ? 'default'
                    : 'ghost'
                }
                className="w-full"
                onClick={() => handleMonthSelect(index)}
              >
                {month}
              </Button>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default MonthPicker
